import BillingStore from 'billing/BillingStore'
import BillingMethod from 'billing/models/BillingMethod'
import { PaymentMethodSelectorPorts } from 'billing/payment-methods/ports'
import Member from 'iam/models/Member'
import Team from 'iam/models/Team'
import { Id } from 'types/definitions'

/**
 * Adapter implementing functionality needed for selecting
 * a payment method.
 */
export default function PaymentMethodSelectorAdapter(
  billingStore: BillingStore,
): PaymentMethodSelectorPorts {
  return {
    billingMethodsFor(member: Member, team: Team | null): BillingMethod[] {
      return team
        ? billingStore.billingMethodsForTeam(team)
        : billingStore.billingMethodsForIndividual(member)
    },

    async fetchBillingProfile(
      member: Member,
      team: Team | null,
    ): Promise<void> {
      if (team) {
        await billingStore.fetchBillingProfileForTeam(Id.assert(team.id))
      } else {
        await billingStore.fetchBillingProfileForIndividual(
          Id.assert(member.workspace.id),
          Id.assert(member.user.publicId),
        )
      }
    },

    canAddMethod(member: Member, team: Team | null): boolean {
      return Boolean(
        team
          ? billingStore.teamBillingProfile(team)?.allowedToManage
          : billingStore.individualBillingProfile(member)?.allowedToManage,
      )
    },
  }
}
